import styled, { css } from 'styled-components';

export const Content = styled.select`
  cursor: pointer;
  padding: 7px 4px;
  height: auto;
  position: relative;
  background-color: #fff;
  border-radius: 3px;
  color: #000;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #4f5761;
      color: #fff;
    `}

  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background-color: var(--cp-surface);
      color: var(--cp-text);
      border: 1px solid var(--cp-border);
      border-radius: 8px;
      padding: 7px 34px 7px 12px;
      /* CP chevron pinned at the end of the control (solid, no dashed) */
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='7' viewBox='0 0 10 7'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%238a8f98' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 12px center;
      transition: border-color 0.15s ease, box-shadow 0.15s ease;
      &:hover {
        border-color: var(--cp-green);
      }
      &:focus {
        outline: none;
        border-color: var(--cp-green);
        box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.12);
      }
      /* keep the open native list on CP surface + green selected item
         (best-effort: honored by browsers that allow option styling) */
      & option {
        background-color: var(--cp-surface);
        color: var(--cp-text);
      }
      & option:checked {
        color: var(--cp-green);
        font-weight: 600;
      }
    `}
`;
